// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Trace extends APIResource {
    /**
     * Retrieve OTEL trace spans for a run.
     *
     * Returns a filtered set of spans relevant for observability:
     *
     * - agent_step: Individual agent reasoning steps
     * - tool executions: Tool call spans
     * - Root span: The top-level request span
     * - time_to_first_token: TTFT measurement span
     *
     * Requires ClickHouse to be configured for trace storage.
     */
    retrieve(runID, query = {}, options) {
        return this._client.get(path `/v1/runs/${runID}/trace`, { query, ...options });
    }
}
//# sourceMappingURL=trace.mjs.map